export default __webpack_public_path__ + "static/media/lxk-logo-2x.b2c7ba49.svg";